export default function HrgsLeaveRoutes(staticTitle) {
    return [
        {
            path: '/hrgs/assessment',
            name: 'hrgs-assessment',
            meta: {
                title: `${staticTitle} - HR & GS`
            },
            component: () => {
                return import('@/views/hrgs/assessment/Index.vue');
            },
            children: [
                {
                    path: 'my-assessment',
                    name: 'myassessment',
                    meta: {
                        title: `${staticTitle} - HR & GS - My Assessment`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/my-assessment/index.vue');
                    }
                },
                {
                    path: 'assessment-list',
                    name: 'assessmentlist',
                    meta: {
                        title: `${staticTitle} - HR & GS - Assessment List`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/assessment-list/Index.vue');
                    }
                }
            ]
        },
        {
            path: '/hrgs/assessment/create',
            name: 'hrgs-assessment-create',
            meta: {
                title: `${staticTitle} - HR & GS`
            },
            component: () => {
                return import('@/views/hrgs/assessment/create.vue');
            },
            children: [
                {
                    path: '/hrgs/assessment/create/personal-data/:id',
                    name: 'hrgs-assessment-create-personaldata',
                    meta: {
                        title: `${staticTitle} - HR & GS - Personal Data`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/Steps/PersonalData.vue');
                    }
                },
                {
                    path: '/hrgs/assessment/create/self-assessment/:id',
                    name: 'hrgs-assessment-create-selfassessment',
                    meta: {
                        title: `${staticTitle} - HR & GS - Self Assessment`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/Steps/SelfAssessment.vue');
                    }
                },
                {
                    path: '/hrgs/assessment/create/pre-assessment/:id',
                    name: 'hrgs-assessment-create-preassessment',
                    meta: {
                        title: `${staticTitle} - HR & GS - Pre Assessment`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/Steps/PreAssessment.vue');
                    }
                },
                {
                    path: '/hrgs/assessment/create/assessment/:id',
                    name: 'hrgs-assessment-create-assessment',
                    meta: {
                        title: `${staticTitle} - HR & GS - Assessment`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/Steps/Assessment.vue');
                    }
                },
                {
                    path: '/hrgs/assessment/create/result/:id',
                    name: 'hrgs-assessment-create-result',
                    meta: {
                        title: `${staticTitle} - HR & GS - Result & Recomendation`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/Steps/ResultAndRecommendation.vue');
                    }
                },
                {
                    path: '/hrgs/assessment/create/certification/:id',
                    name: 'hrgs-assessment-create-certification',
                    meta: {
                        title: `${staticTitle} - HR & GS - Certification`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/Steps/Certification.vue');
                    }
                },
                {
                    path: '/hrgs/assessment/create/detail-result/:id',
                    name: 'hrgs-assessment-create-detailresult',
                    meta: {
                        title: `${staticTitle} - HR & GS - Detail Result`
                    },
                    component: () => {
                        return import('@/views/hrgs/assessment/Steps/DetailResult.vue');
                    }
                }
            ]
        }
    ];
}
